<template>
  <v-row class="ma-0">
    <v-col class="pa-0 token-text-font-iAWriterDuoV token-text-regular token-text-color-secondary mr-2 fit-content" v-if="!hideData">
      {{ $helpers.dates.formatDateTime(log.attributes.time) }}
    </v-col>
    <v-col class="pa-0 token-text-font-iAWriterDuoV token-text-regular token-text-color-secondary mr-2 fit-content" v-if="!hideData">
      {{ log.attributes.container }}
    </v-col>
    <v-col class="pa-0 token-text-font-iAWriterDuoV token-text-regular token-text-color-primary" v-if="!hideMessage">
      {{ log.attributes.message }}
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { Vue, prop } from 'vue-class-component';
import { APILiveLog } from '@/typesAPI'

class Props {
  log:APILiveLog = prop({
    required: true,
  });
  hideData?:boolean = prop({
    required: false,
  });
  hideMessage?:boolean = prop({
    required: false,
  });
}
export default class LogLine extends Vue.with(Props) {

}
</script>

<style lang="scss">
@import '@/css/variables';

</style>
